import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { IShopFeatures } from "@/shop/types/personalized";

import * as PersonalizedAreaActions from "../actions";
import type { IShopFeatureState } from "./types";

const initialState: IShopFeatureState = {
  data: {} as IShopFeatures, // these should have been optional properties anyway
  hasError: false,
  isFetching: false
};

export default function featuresReducer(state: IShopFeatureState = initialState, action: ActionType<typeof PersonalizedAreaActions>): IShopFeatureState {
  switch (action.type) {
    case getType(PersonalizedAreaActions.detectFeaturesStart): {
      return {
        ...state,
        isFetching: true
      };
    }

    case getType(PersonalizedAreaActions.detectFeaturesFail): {
      return {
        ...state,
        hasError: true,
        isFetching: false
      };
    }

    case getType(PersonalizedAreaActions.detectFeaturesSuccess): {
      return {
        ...state,
        data: action.payload,
        isFetching: false
      };
    }

    default:
      return state;
  }
}
